



































import { UserRole } from '@/resource/user/user.model';
import { getRole } from '@/utils/cookie';
import { Component, Vue } from 'vue-property-decorator';
import QuestionUploadStore, {
  QuestionUploadStoreInterface,
  fetchOneQuestion,
} from '@/resource/question-upload/question-upload.store';
import UploadQuestionContainer from '@/components/upload-questions/UploadQuestionContainer.vue';
import UploadQuestionForm from '@/components/upload-questions/UploadQuestionForm.vue';
import UploadQuestionPreview from '@/components/upload-questions/UploadQuestionPreview.vue';
import { Question } from '@/resource/question/question.model';

@Component({
  components: {
    UploadQuestionContainer,
    UploadQuestionForm,
    UploadQuestionPreview,
  },
})
export default class UploadQuestion extends Vue {
  isLoading = true;
  isQuestionsLoading = false;
  isSendLoading = false;
  uploadQuestionStore: QuestionUploadStoreInterface = QuestionUploadStore;

  objectives: Question[] = [];
  subjectives: Question[] = [];

  objectiveIds = {
    value: '',
    error: false,
  };

  subjectiveIds = {
    value: '',
    error: false,
  };

  get uploadQuestionId() {
    const id = Number(this.$route.params.id);

    if (isNaN(id)) {
      return -1;
    } else {
      return id;
    }
  }

  get userRole(): UserRole | null {
    return getRole();
  }

  get uploadQuestion() {
    return this.uploadQuestionStore.questionUpload;
  }

  get uploadQuestions() {
    return this.uploadQuestionStore.questionUpload
      ? [this.uploadQuestionStore.questionUpload]
      : [];
  }

  async fetchUploadQuestion() {
    this.isLoading = true;
    await this.uploadQuestionStore.fetchQuestionUpload(this.uploadQuestionId);
    this.isLoading = false;
  }

  async created() {
    await this.fetchUploadQuestion();
  }

  async fetchQuestions() {
    this.isQuestionsLoading = true;
    this.objectives = [];
    this.subjectives = [];
    const objectiveIds = this.extractIds(this.objectiveIds.value);
    const subjectiveIds = this.extractIds(this.subjectiveIds.value);

    for (const id of objectiveIds) {
      const question = await fetchOneQuestion(id, false);

      if (question && question.isDraft) {
        this.objectives.push(question);
      }
    }

    for (const id of subjectiveIds) {
      const question = await fetchOneQuestion(id, true);

      if (question && question.isDraft) {
        this.subjectives.push(question);
      }
    }

    this.objectiveIds.value = this.objectives.map(q => q.id).join(',');
    this.subjectiveIds.value = this.subjectives.map(q => q.id).join(',');

    this.isQuestionsLoading = false;
  }

  async sendQuestions() {
    this.isSendLoading = true;
    const objectiveIds = this.extractIds(this.objectiveIds.value);
    const subjectiveIds = this.extractIds(this.subjectiveIds.value);

    if (!objectiveIds.length && !subjectiveIds.length) {
      this.$toasted.global.mainToast({
        message: 'Please add at least one question',
      });

      this.isSendLoading = false;
      return;
    }

    await this.uploadQuestionStore.sendQuestionUpload({
      objectiveIds,
      subjectiveIds,
      questionUploadId: this.uploadQuestionId,
    });

    if (this.uploadQuestionStore.error) {
      this.$toasted.global.mainToast({
        message: this.uploadQuestionStore.error.message,
      });
    } else {
      this.$router.go(0);
    }

    this.isSendLoading = false;
  }

  extractIds(ids: string): number[] {
    return ids
      .split(',')
      .filter(id => {
        const i = Number(id);

        if (!isNaN(i)) {
          return i;
        } else {
          return null;
        }
      })
      .map(id => Number(id));
  }
}
